import { createReducer, on } from '@ngrx/store';
import {
    loadWkfSupervisionParamsSucceedAction,
    removeWkfSupervisionParamsSucceedAction
} from '../action/current-supervision.action';
import { WkfSupervisionParams } from '../../../models/workflow/wkf-supervision-params';


export class CurrentSupervision {
    currentWkfSupervisionParams?: WkfSupervisionParams;
}

export class CurrentSupervisionState {
    datas: CurrentSupervision;
    loading: boolean;
    error: any;
}


export const CURRENT_SUPERVISION_INITIAL_STATE: CurrentSupervisionState = {
    datas: {
        currentWkfSupervisionParams:null,
    },
    loading: false,
    error: null,
};

export const currentSupervisionReducer = createReducer(
    CURRENT_SUPERVISION_INITIAL_STATE,

    on(loadWkfSupervisionParamsSucceedAction, ( state, {payload}) => ({
        ...state,
        datas: {
            ...state.datas,
            currentWkfSupervisionParams: payload
        },
        loading: false,
        error: null,
    })),

    on(removeWkfSupervisionParamsSucceedAction, (state) => ({
        ...state,
        datas: {
            ...state.datas,
            currentSupervisionMatTableColumnDefs: null,
        },
        loading: false,
        error: null,
    })),
);

